import { AllDayItem } from 'mini-calendar-day-surface';
import CalendarEvent from 'mini-calendar-event-types/lib/MiniCalendarEvent';
import DayViewItem from 'mini-day-view/lib/schema/DayViewItem';
import getDayViewStore from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator to save day view items
 */
const saveDayViewState = mutatorAction(
    'saveDayViewState',
    (
        itemsToSave: { [key: string]: DayViewItem<CalendarEvent>[] },
        allDayItemsToSave: { [key: string]: AllDayItem[] },
        clearAll?: boolean
    ) => {
        const { dayViewInDayItemsMap, dayViewAllDayItemsMap } = getDayViewStore();
        if (clearAll) {
            dayViewInDayItemsMap.clear();
            dayViewAllDayItemsMap.clear();
        }
        Object.keys(itemsToSave).forEach(key => {
            dayViewInDayItemsMap.set(key, itemsToSave[key]);
        });
        Object.keys(allDayItemsToSave).forEach(key => {
            dayViewAllDayItemsMap.set(key, allDayItemsToSave[key]);
        });
    }
);

export default saveDayViewState;
